import { Spinner } from '@/components/ui/spinner';
import { useApp } from '@/context/AppContext';

export function FullPageLoader() {
  const { shortName } = useApp();
  return (
    <output className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background/80 backdrop-blur-sm">
      <Spinner size="lg" />
      <p className="mt-4 text-lg text-muted-foreground">Loading {shortName}...</p>
    </output>
  );
}
